<template>
  <div>
    <h5 class="text-uppercase font-weight-bold h6 pt-2">
      <label>Notes:</label>
    </h5>
    <trix class="trix-mini border-0" />
  </div>
</template>

<style scoped>
.border-top-1 {
  border-top: 1px solid #111;
}
</style>

<script>
import Trix from '@/components/Trix'

export default {
  components: {
    Trix
  }
}
</script>